import React, { useState } from 'react'
import { Badges, H3, H5, H6, LI, P, UL } from '../../../AbstractElements'
import { Href, NotificationTitle } from '../../../Utils/Constants';
import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons';
import { useNotifications } from '../../../hooks/notifications/useNotifications'; // custom hook

export default function Notification() {
    const [notifyDropdown, setNotifyDropdown] = useState(false);
    const toggle = () => setNotifyDropdown((prevState) => !prevState);

    // Get notifications from hook
    const { notifications, loading, error } = useNotifications();

    return (
      <LI className="custom-dropdown">
        <a href={Href} onClick={toggle}>
          <SvgIcon iconId="notification" />
        </a>
        <Badges color="primary" pill>
          {notifications?.length ?? 0}
        </Badges>

        <div className={`custom-menu notification-dropdown py-0 overflow-hidden ${notifyDropdown ? 'show' : ''}`}>
          <H3 className="title bg-primary-light dropdown-title">
            {NotificationTitle} <span className="font-primary">{'View all'}</span>
          </H3>
          <p className="text-muted text-center small px-3 py-2 mb-0 border-bottom">
            Select the notification icon again to close this panel
          </p>
          <UL className="activity-timeline simple-list">
            {loading && (
              <LI className="text-center py-3">
                <span>Loading notifications...</span>
              </LI>
            )}
            {error && (
              <LI className="text-center py-3 text-danger">
                <span>Error loading notifications</span>
              </LI>
            )}
            {!loading && !error && notifications?.length === 0 && (
              <LI className="text-center py-3">
                <span>No notifications found</span>
              </LI>
            )}
            {!loading && !error && notifications?.map((item: any) => (
              <LI className="d-flex align-items-start" key={item._id}>
                <div className="activity-line" />
                <div className={`activity-dot-primary`} />
                <div className="flex-grow-1">
                  <H6 className={`f-w-600 font-primary`}>
                    {/* Show date and type */}
                    {item.createdAt ? new Date(item.createdAt).toLocaleDateString() : ''}
                    <span>{item.notificationType}</span>
                    {/* <span className={`circle-dot-primary float-end`}>
                      <SvgIcon className="circle-color" iconId="circle" />
                    </span> */}
                  </H6>
                  <H5>
                    {/* Show sender name if available */}
                    {item.notificationFrom?.firstname
                      ? `${item.notificationFrom.firstname} ${item.notificationFrom.lastname}`
                      : 'System'}
                  </H5>
                  <P>{item.content}</P>
                </div>
              </LI>
            ))}
          </UL>
        </div>
      </LI>
    )
}